import { createContext } from 'react';
import type { AppearanceConfig } from './appearance';
import type { AppScreens } from '../screenBuilder/model';

export type PresentationSnapshot = { version: 1; appearance: AppearanceConfig | null; screens: AppScreens | null };
export const PresentationContext = createContext<PresentationSnapshot | null>(null);

export const PresentationPendingContext = createContext(false);
